import { Select } from '@/components/common/Select';
import { WindCompassRose } from '@/components/waypoint/WindCompassRose';
import { useWeatherStore } from '@/stores/weather-store';
import type { BlindMetadata } from '@/types/waypoint';

interface BlindFormProps {
  metadata: Partial<BlindMetadata>;
  onChange: (updated: Partial<BlindMetadata>) => void;
  /** The property this blind belongs to — used to fetch current wind bearing. */
  propertyId: string;
  /** When true, omits the wind compass (used on detail page where it appears in its own section) */
  hideWindCompass?: boolean;
}

const BLIND_TYPE_OPTIONS = [
  { value: 'box', label: 'Box Blind' },
  { value: 'ground', label: 'Ground Blind' },
  { value: 'elevated', label: 'Elevated Stand' },
  { value: 'hub', label: 'Hub Blind' },
  { value: 'observation_tower', label: 'Observation Tower' },
  { value: 'other', label: 'Other' },
];

const TIME_OF_DAY_OPTIONS = [
  { value: 'morning', label: 'Morning' },
  { value: 'evening', label: 'Evening' },
  { value: 'all_day', label: 'All Day' },
];

export function BlindForm({ metadata, onChange, propertyId, hideWindCompass = false }: BlindFormProps) {
  const currentWindBearing = useWeatherStore((s) => s.getConditions(propertyId)?.windDeg ?? null);

  return (
    <div className="flex flex-col gap-4">
      <Select
        id="blind-type"
        label="Blind Type"
        value={metadata.blindType ?? 'elevated'}
        onChange={(v) =>
          onChange({ ...metadata, blindType: v as BlindMetadata['blindType'] })
        }
        options={BLIND_TYPE_OPTIONS}
      />

      <Select
        id="blind-time-of-day"
        label="Best Time of Day"
        value={metadata.bestTimeOfDay ?? 'all_day'}
        onChange={(v) =>
          onChange({ ...metadata, bestTimeOfDay: v as BlindMetadata['bestTimeOfDay'] })
        }
        options={TIME_OF_DAY_OPTIONS}
      />

      {!hideWindCompass && (
        <WindCompassRose
          selectedDirections={metadata.idealWindDirections ?? []}
          onChange={(dirs) => onChange({ ...metadata, idealWindDirections: dirs })}
          currentWindBearing={currentWindBearing}
        />
      )}

      {/* I-5: "Set on Map" link removed — map-based wind picker is not implemented */}
    </div>
  );
}
